// @file Network requests related to wall translation

import { asciiSafeStringify } from '@@/bits/json_stringify'
import type { VersionedFetchOptions } from '@@/surface/api/fetchable_object'
import FetchableObject from '@@/surface/api/fetchable_object'
import { fetchJson } from '@@/surface/api_fetch'
import type { TranslatedEntity, TranslatedWall, WallId } from '@@/types'
import { HTTPMethod } from '@padlet/fetch'

class WallTranslationApi extends FetchableObject {
  public static async translate(
    wallId: WallId,
    lang: string,
    fetchOptions: VersionedFetchOptions = {},
  ): Promise<TranslatedWall> {
    const { apiVersion = 1, ...otherFetchOptions } = fetchOptions
    const response = await fetchJson(`/api/${apiVersion}/walls/${wallId}/translation`, {
      method: HTTPMethod.post,
      body: asciiSafeStringify({ lang }),
      ...otherFetchOptions,
    })

    return response.data.attributes as TranslatedWall
  }

  public static async translateEntity(
    wallId: WallId,
    entityType: string,
    lang: string,
    entityId?: string,
    fetchOptions: VersionedFetchOptions = {},
  ): Promise<TranslatedEntity> {
    const { apiVersion = 1, ...otherFetchOptions } = fetchOptions
    const response = await fetchJson(`/api/${apiVersion}/walls/${wallId}/entity-translation`, {
      method: HTTPMethod.post,
      body: asciiSafeStringify({ entity_type: entityType, entity_id: entityId, lang }),
      ...otherFetchOptions,
    })

    return response.data.attributes as TranslatedEntity
  }
}

export { WallTranslationApi }
